// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"424": "27cfe973928c5867","757": "d10f954e37ae4183",}[chunkId] + ".css"
}